export const getVenueBounds = venue => ({
  east: venue.bounds.ne.longitude,
  north: venue.bounds.ne.latitude,
  south: venue.bounds.sw.latitude,
  west: venue.bounds.sw.longitude,
})

